import { render, staticRenderFns } from "./TxPatientView.vue?vue&type=template&id=28502ab8&scoped=true"
import script from "./TxPatientView.vue?vue&type=script&lang=js"
export * from "./TxPatientView.vue?vue&type=script&lang=js"
import style0 from "./TxPatientView.vue?vue&type=style&index=0&id=28502ab8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28502ab8",
  null
  
)

export default component.exports